import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllWineries, getAllSubWineries, getAllWarehouses, getAllRepresentatives, getAllFranchises } from '../../../../../actions/inventoryActions'
import InventoryLocationsListView from '../../../../containers/Inventory/InventoryLocations/InventoryLocationsList/InventoryLocationsList'
import { useHistory } from "react-router-dom";



const InventoryLocationsList = ({match}) => {
  const history = useHistory();

  let auxFunction;
  let inventoryType = match.params.inventoryType;
  const limitInventoryItems = 100;

  const dispatch = useDispatch();

  const { wineries, subWineries, warehouses, representatives, franchises } = useSelector(state => state.inventory);

  const [skip, setSkip] = useState(0);
  const [search, setSearch] = useState('')
  const auxInventoryItems = [];

  const onClickRow = (inventoryType, id, locationName) => {

    if((inventoryType=='Winery')||(inventoryType=='SubWinery')||(inventoryType=='EcoCEO')){
      history.push(`/Admin/Inventory/ProductLocationsList/Location/${ id }/${ locationName }`)
    }

    else if((inventoryType=='EcoMaster')||(inventoryType=='EcoTiendas')){
      history.push(`/Admin/Inventory/ProductLocationsList/Entity/${ id }/${ locationName }`)
    }
  }
  
  useEffect(() => {
    switch(inventoryType){
      case 'Winery':
        auxFunction = dispatch(getAllWineries(search, limitInventoryItems, skip));
        break;

      case 'SubWinery':
        auxFunction = dispatch(getAllSubWineries(search, limitInventoryItems, skip));
        break;
      
      case 'EcoCEO':
        auxFunction = dispatch(getAllWarehouses(search, limitInventoryItems, skip));
        break;
      
      case 'EcoMaster':
        auxFunction = dispatch(getAllRepresentatives(search, limitInventoryItems, skip));
        break;
      
      case 'EcoTiendas':
        auxFunction = dispatch(getAllFranchises(search, limitInventoryItems, skip));
        break;

      default:
        console.log()
  }
  return () => { 

    
  }
  }, [search]);
  



  switch(inventoryType){
    case 'Winery':
      try{
        wineries.forEach((array)=>{
          auxInventoryItems.push({
            id:array._id,
            code: array.code,
            name:array.name,
            location:array.ubication.city
          });
        });
      }
      catch(e){}
      break;

    case 'SubWinery':
      try{
        subWineries.forEach((array)=>{
          auxInventoryItems.push({
            id:array._id,
            code: array.code,
            name:array.name,
            location:array.wineryId.ubication.city
          });
        });
      }
      catch(e){}
    break;
    
    case 'EcoCEO':
      try{
        warehouses.forEach((array)=>{
          auxInventoryItems.push({
            id:array._id,
            code: array.code,
            name:array.name,
            location:array.ubication.businessCity
          });
        });

      }
      catch(e){}
    break;
    
    case 'EcoMaster':
      try{
        representatives.forEach((array)=>{
          auxInventoryItems.push({
            id:array._id,
            code: array.code,
            name:`${array.userID.name} ${array.userID.lastname}`,
            location:array.ubication?.businessCity

          });
        });
      }
      catch(e){}
    break;
    
    case 'EcoTiendas':
      try{
        franchises.forEach((array)=>{
          auxInventoryItems.push({
            id:array._id,
            code: array.code,
            name:array.socialReason,
            location:array.ubication.businessCity
          });
        });
      }
      catch(e){}
    break;

    default:
      console.log()
  }  

  useEffect(() => {
    clearAuxInventoryItems();
    
    return () => {

    }
  }, [search]);


  const clearAuxInventoryItems = () => {
    wineries.length = 0;
    subWineries.length = 0;
    warehouses.length = 0;
    representatives.length = 0;
    franchises.length = 0
    setSkip(0);
    auxInventoryItems.length = 0;
    
    }
  
  return (
    <InventoryLocationsListView
      inventoryItems={auxInventoryItems}
      limit={limitInventoryItems}
      skip={skip}
      setSkip={setSkip}
      setSearch={setSearch}
      onClickRow={onClickRow}
      inventoryType={inventoryType}
    />
  )
}

export default InventoryLocationsList